<div id="line{{index}}" #line class="donut{{index}} h-100 w-100">
    <p *ngIf="!lineData.length" class="mt">No Data</p>
</div>